import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { FaStar, FaComment, FaSmile, FaPaperPlane } from 'react-icons/fa';
import ClientLayout from '../layouts/ClientLayout';

function ClientFeedback({ onLogout }) {
  const [user, setUser] = useState({});
  const [rating, setRating] = useState(0);
  const [hoverRating, setHoverRating] = useState(0);
  const [comment, setComment] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (rating === 0) {
      toast('Please select a rating');
      return;
    }
    setSubmitted(true);
    setTimeout(() => setSubmitted(false), 3000);
  };

  return (
    <ClientLayout activeTab="feedback" onLogout={onLogout} user={user}>
      <div className="flex items-center gap-4 mb-6">
        <div>
          <h1 className="text-2xl font-bold" style={{ color: '#0A1929' }}>💬 Feedback</h1>
          <p className="text-sm" style={{ color: '#4A5568' }}>Share your experience with us</p>
        </div>
      </div>

      {submitted ? (
        <div className="bg-white rounded-xl border p-12 text-center" style={{ borderColor: '#E8ECEF' }}>
          <div className="text-6xl mb-4">🎉</div>
          <h2 className="text-2xl font-bold text-green-600 mb-2">Thank You!</h2>
          <p className="text-gray-500">Your feedback has been submitted successfully.</p>
        </div>
      ) : (
        <div className="bg-white rounded-xl border p-6" style={{ borderColor: '#E8ECEF' }}>
          <form onSubmit={handleSubmit}>
            <div className="mb-6 text-center">
              <p className="text-sm font-medium mb-2" style={{ color: '#0A1929' }}>How would you rate your experience?</p>
              <div className="flex justify-center gap-2 text-3xl">
                {[1, 2, 3, 4, 5].map((star) => (
                  <button
                    key={star}
                    type="button"
                    onClick={() => setRating(star)}
                    onMouseEnter={() => setHoverRating(star)}
                    onMouseLeave={() => setHoverRating(0)}
                    className="focus:outline-none transition-transform hover:scale-110"
                  >
                    <FaStar
                      className={star <= (hoverRating || rating) ? 'text-yellow-400' : 'text-gray-300'}
                    />
                  </button>
                ))}
              </div>
              <p className="text-xs mt-2" style={{ color: '#4A5568' }}>
                {rating === 1 ? 'Poor' : rating === 2 ? 'Fair' : rating === 3 ? 'Good' : rating === 4 ? 'Very Good' : rating === 5 ? 'Excellent' : 'Click to rate'}
              </p>
            </div>

            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-1">Your Feedback</label>
              <textarea
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                rows="4"
                placeholder="Tell us about your experience..."
                className="w-full px-4 py-2 rounded-lg border focus:outline-none focus:border-green"
                style={{ borderColor: '#E8ECEF' }}
                required
              />
            </div>

            <button
              type="submit"
              className="w-full px-6 py-3 rounded-lg text-white font-medium transition-colors flex items-center justify-center gap-2"
              style={{ backgroundColor: '#00A86B' }}
              onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#00995E'}
              onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#00A86B'}
            >
              <FaPaperPlane size={14} /> Submit Feedback
            </button>
          </form>
        </div>
      )}
    </ClientLayout>
  );
}

export default ClientFeedback;
